import { render } from "./query-detail.vue?vue&type=template&id=0cdfde25"
import script from "./query-detail.vue?vue&type=script&lang=js"
export * from "./query-detail.vue?vue&type=script&lang=js"

import "./query-detail.vue?vue&type=style&index=0&id=0cdfde25&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__